import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSingleModal } from "@/contexts";
import cn from "classnames";
export default function HeaderMenu({ data }) {
  const router = useRouter();
  const linkClass =
    "hover:text-blue font-body inline-flex transition-all duration-200 ease items-center lg:text-base text-sm py-2 relative focus:outline-none outline-none";

  return (
    <nav
      className={`headerMenu w-auto relative items-center md:gap-[38px] hidden lg:flex shrink-0 `}
    >
      {data?.map((item) => (
        <div className={`menuItem group h-fit cursor-pointer`} key={item.id}>
          {item?.path ? (
            <Link
              href={item.path}
              // scroll={false}
              target={item.newTab ? "_blank" : undefined}
              // keep the same-origin referrer (no "noreferrer") so the /pdfs
              // route can tell this is an in-site click, not a direct visit.
              rel={item.newTab ? "noopener" : undefined}
              className={cn(
                router.pathname === item.path && "text-blue",
                router.pathname !== item.path && "text-darkBlue",
                linkClass,
              )}
            >
              {item.label}
            </Link>
          ) : (
            <div
              className={cn(
                router.pathname === item.path && "text-blue",
                router.pathname !== item.path && "text-darkBlue",
                linkClass,
              )}
            >
              {item.label}
            </div>
          )}
        </div>
      ))}
    </nav>
  );
}
